import { axios } from "~/plugins/request"

export function getDictionary(params) {
  return axios({
    method: 'post',
    url: '/fwxtdictionary/findAllItemByTypeCode',
    params: params
  })
}

export function findBasicConfigData(data) {
  return axios({
    method: 'get',
		url: '/art/oldPlan/findBasicConfigData',
    params: data
  })
}

export function saveLeaveMessage(data) {
  return axios({
    method: 'post',
		url: '/art/initialPlan/saveLeaveMessage',
    data: data
  })
}

export function findSpecialityList(data) {
  return axios({
    method: 'post',
		url: '/art/newPlan/findUniversityQueryList',
    data: data
  })
}

export function save(data) {
  return axios({
    method: 'post',
		url: '/art/newPlan/save',
    data: data
  })
}

export function findSchemeList(data) {
  return axios({
    method: 'post',
		url: '/art/newPlan/selectSchemeList',
    data: data
  })
}

export function getSchemeDetail(data) {
  return axios({
    method: 'get',
		url: '/art/newPlan/selectProgramInfo',
    params: data
  })
}

export function getSchemeDetailEdit(data) {
  return axios({
    method: 'get',
		url: '/art/newPlan/selectProgramInfoEdit',
    params: data
  })
}

export function remove(data) {
  return axios({
    method: 'get',
		url: '/art/oldPlan/remove',
    params: data
  })
}

export function saveAndSend(data) {
  return axios({
    method: 'get',
		url: '/art/oldPlan/sendScheme',
    params: data
  })
}


export function saveOrUpdateField(data) {
  return axios({
    method: 'post',
		url: '/configPlanField/saveOrUpdateField',
    data: data
  })
}

export function artSaveLeaveMessage(data) {
  return axios({
    method: 'post',
		url: '/art/oldPlan/saveLeaveMessage',
    data: data
  })
}

export function getItemByTypeCode (data) {
  return axios({
    method: 'get',
		url: 'dictionary/findAllItemByTypeCode?typeCode=' + data.typeCode,
    data: data
  })
}

export function artDesignThoughtSave(data) {
  return axios({
    method: 'post',
		url: '/art/oldPlan/updateSchemeDesignThought',
    data: data
  })
}

export function selectInitialSchemeList(data) {
  return axios({
    method: 'post',
    url: '/project/final/selectLastProgramList',
    data: data
  })
}

export function getSchemeDetailForNewPlanByLastStep(data) {
  return axios({
    method: 'get',
		url: '/report/newPlan/selectProgramInfoLast',
    params: data
  })
}



